import PhoneState from './PhoneState';
import { PhoneStateParams, PhoneModeType } from './PhoneState.type';

export default PhoneState;

export type { PhoneModeType, PhoneStateParams };
